import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProfileCategoriesService} from '~/app/core/common/services/profile-categories.service';
import {CustomerCategory} from '~/app/core/common/models/customerCategory';

@Component({
    selector: 'app-categories',
    templateUrl: './categories.component.html',
    styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

    constructor(public profileCategoriesService: ProfileCategoriesService) {
    }

    @Output() categoryOutput = new EventEmitter<CustomerCategory>();
    @Input() page: String;
    private selected: boolean;

    ngOnInit() {
        if (this.profileCategoriesService.customerCategories !== undefined) {
            this.profileCategoriesService.customerCategories.sort((a, b) => {
                //modifing sort logic to place the 'ALL ITEMS' at first always
               
            if (a.description === 'ALL ITEMS') {
                return -1;
            }
            if (b.description === 'ALL ITEMS') {
                return 1;
            }
               if (a.description > b.description) {
                return 1;
            }
        
            if (a.description < b.description) {
                return -1;
            }
             return 0;
            });
            //at the initial stage set the 'All ITEMs' as an selected item
            this.profileCategoriesService.customerCategories.map(i => 
                {
                    if (i.description === 'ALL ITEMS') {
                        i.selected = true
                        this.categoryClicked(Event , i)
                    }else {
                        i.selected = false
                    }
                })
            if (this.page === 'profile-items') {
                if ((this.profileCategoriesService.selectedCategory.description === 'CRITICAL ITEMS')
                    || (this.profileCategoriesService.selectedCategory.description === 'HOLD ITEMS')) {
                    this.profileCategoriesService.customerCategories.forEach(cat => {
                        if (cat.description === 'ALL ITEMS') {
                            cat.selected = true;
                            this.profileCategoriesService.selectedCategory = cat;
                        } else {
                            cat.selected = false;
                        }
                    });
                }
                this.profileCategoriesService.customerCategories = this.profileCategoriesService.customerCategories.filter(e => {
                    // if ((e.description === 'CRITICAL ITEMS') || (e.description === 'HOLD ITEMS'))
                       if ((e.description === 'HOLD ITEMS'))
                     {
                        this.profileCategoriesService.selectedCategory.selected = false;
                        return false;
                    }
                    return true;
                });
                this.profileCategoriesService.selectedCategory.selected = true; // TODO find out why i'm setting this to TRUE
            } else {
                this.profileCategoriesService.customerCategories = this.profileCategoriesService.originalList;
                this.profileCategoriesService.customerCategories.forEach(cat => {
                    if (cat.description === 'ALL ITEMS') {
                        cat.selected = true;
                        this.profileCategoriesService.selectedCategory = cat;
                    } else {
                        cat.selected = false;
                    }
                });
            }
        }
    }

    categoryClicked($event: any, customerCategory: CustomerCategory) {
        this.profileCategoriesService.customerCategories.forEach(cat => {
            if (cat.uniqueCategoryId === customerCategory.uniqueCategoryId) {
                cat.selected = true;
                this.profileCategoriesService.selectedCategory = cat;
            } else {
                cat.selected = false;
            }
        });
        this.profileCategoriesService.selectedCategory = customerCategory;
        this.categoryOutput.emit(customerCategory);
    }
}
